"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../styles/ImageUpload.scss");
var _Button = require("@ccw-pwa-ui/Button");
var _SuccessModal = _interopRequireDefault(require("./SuccessModal"));
var _Modal = require("@ccw-pwa-ui/Modal");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
const AddNotes = _ref => {
  let {
    navHeading,
    onBackPress,
    onClickCancel,
    leftArrow,
    cancelText,
    headerText,
    addNotesHeader,
    notesText,
    onChangeNotes,
    subNotesText,
    saveText,
    onClickSave,
    isButtonDisabled,
    currentPage,
    totalPage,
    showSuccessModal,
    handleSuccessModal,
    successModalBtnTitle,
    successModalData,
    subText,
    showSteps = true,
    isAccessoryPresent,
    saveErrorModalData,
    showUpdateSuccessModal,
    showUpdateErrorModal,
    isUpdating,
    detailsArray
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "image-layout"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    handleBack: onBackPress,
    handleCancle: onClickCancel,
    leftArrowImage: leftArrow,
    rightNavHeading: cancelText
  }), showSteps ? /*#__PURE__*/_react.default.createElement("div", {
    className: "stepCountClass"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "notesTitleWrapper",
    style: {
      fontFamily: "poppins",
      fontSize: 18
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 10
    },
    "data-testid": "title-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText,
    headerStyle: {
      fontSize: '27px',
      fontWeight: 600
    }
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subText,
    headerStyle: {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0px',
      textAlign: 'left'
    }
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-area-container",
    "data-testid": "sub-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: addNotesHeader
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-area"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    "data-testid": "text-area",
    maxLength: 250,
    id: "textarea",
    placeholder: addNotesHeader,
    onChange: onChangeNotes,
    style: {
      borderRadius: '10px',
      borderColor: "#EBEBEB",
      padding: "10px",
      height: "150px",
      width: "100%",
      outline: "none",
      borderWidth: '2px'
    }
  }, notesText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-notes",
    "data-testid": "sub-notes"
  }, subNotesText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "notesSubmitButton"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "save-click"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: isButtonDisabled,
    variant: "primary-long",
    title: saveText,
    onClick: onClickSave
  }))), showSuccessModal ? /*#__PURE__*/_react.default.createElement(_SuccessModal.default, {
    handleSuccessModal: handleSuccessModal,
    showSuccessModal: showSuccessModal,
    successModalBtnTitle: successModalBtnTitle,
    successModaldata: successModalData,
    isAccessoryPresent: isAccessoryPresent,
    detailsArray: detailsArray
  }) : "", showUpdateSuccessModal && /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayCrossIcon: successModalData === null || successModalData === void 0 ? void 0 : successModalData.displayCrossIcon,
    modalHeaderText: successModalData === null || successModalData === void 0 ? void 0 : successModalData.modalHeaderText,
    modalHeaderTextStyle: successModalData === null || successModalData === void 0 ? void 0 : successModalData.modalHeaderTextStyle,
    modalHeaderIcon: successModalData === null || successModalData === void 0 ? void 0 : successModalData.modalHeaderIcon,
    variant: successModalData === null || successModalData === void 0 ? void 0 : successModalData.variant,
    positiveActionButtonTitle: successModalData === null || successModalData === void 0 ? void 0 : successModalData.positiveActionButtonTitle,
    modalDetailText: successModalData === null || successModalData === void 0 ? void 0 : successModalData.modalDetailText,
    displayModal: true,
    negativeButtonActionTitle: successModalData === null || successModalData === void 0 ? void 0 : successModalData.negativeButtonActionTitle,
    positiveAction: successModalData === null || successModalData === void 0 ? void 0 : successModalData.positiveAction,
    crossIconAction: successModalData === null || successModalData === void 0 ? void 0 : successModalData.crossIconAction,
    negativeAvtion: successModalData === null || successModalData === void 0 ? void 0 : successModalData.negativeAvtion
  })), showUpdateErrorModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.displayModal,
    modalHeaderText: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderText,
    modalHeaderTextStyle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderTextStyle,
    modalDetailText: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalDetailText,
    modalHeaderIcon: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderIcon,
    displayCrossIcon: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.displayCrossIcon,
    variant: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.variant,
    positiveActionButtonTitle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.positiveActionButtonTitle,
    positiveAction: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.positiveAction,
    negativeButtonActionTitle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.negativeButtonActionTitle,
    crossIconAction: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.crossIconAction,
    negativeAvtion: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.negativeAvtion
  }));
};
var _default = exports.default = AddNotes;